import { ButtonColorEnum, ButtonVariantEnum } from '@app/app.enum';
import { ICustomDialogProps } from '@app/models/shared.models';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import * as React from 'react';
import { injectIntl } from 'react-intl';
import CustomButton from './custom-button.component';

const defaultProps: ICustomDialogProps = {
	dialogDescription: null,
	dialogNoButton: null,
	dialogYesButton: null,
	open: false,
	fullWidth: false,
	dialogTitle: null,
	closeCustomDialog: (...args) => {},
	intl: null,
	submitButton: {
		isSubmit: false,
		isLoading: false,
		isDisabled: false,
		onSubmit: () => {},
	},
	children: null,
	fullScreen: false,
	maxWidth: 'sm',
	disableEscapeKeyDown: false,
	noButtonVariant: ButtonVariantEnum.Outlined,
	yesButtonVariant: ButtonVariantEnum.Contained,
	hideSubmitActionButton: false,
};
const CustomDialogBox = (props: ICustomDialogProps) => {
	// Separate token must be used in component individually
	// because using HoC for custom dialog producing some issues
	// while cancelling Axios Requests
	const {
		intl,
		children,
		dialogNoButton,
		dialogYesButton,
		submitButton,
		dialogTitle,
		component,
		closeCustomDialog,
		dialogDescription,
		noButtonVariant,
		yesButtonVariant,
		dialogId,
		loading,
		disabled,
		hideSubmitActionButton,
		...restDialogProps
	} = props;
	const defaultNoButtonText = intl.formatMessage({
		id: 'app.common.dialog-cancel-button-text',
	});
	const defaultYesButtonText = intl.formatMessage({
		id: 'app.common.dialog-confirm-button-text',
	});

	const finalDialogNoButton = dialogNoButton || defaultNoButtonText;
	const finalDialogYesButton = dialogYesButton || defaultYesButtonText;
	const { isSubmit, onSubmit, isLoading, isDisabled } = { ...submitButton };

	return (
		<Dialog {...restDialogProps} onClose={() => closeCustomDialog(dialogTitle, true)}>
			<DialogTitle>{dialogTitle}</DialogTitle>
			<DialogContent>{children || <DialogContentText component='span' children={dialogDescription} />}</DialogContent>
			<DialogActions>
				{!!component ? (
					component
				) : (
					<>
						{/* Dialog No Button */}
						<CustomButton
							color={ButtonColorEnum.Primary}
							variant={noButtonVariant}
							onClick={() => closeCustomDialog(dialogId, true)}
							buttonText={finalDialogNoButton}
						/>
						{/* Dialog Yes Button */}
						{!hideSubmitActionButton && (
							<CustomButton
								color={ButtonColorEnum.Secondary}
								variant={yesButtonVariant}
								onClick={() => (isSubmit ? onSubmit() : closeCustomDialog(dialogId, false))}
								buttonText={finalDialogYesButton}
								autoFocus={true}
								loading={isLoading || loading}
								disabled={isDisabled || disabled}
							/>
						)}
					</>
				)}
			</DialogActions>
		</Dialog>
	);
};

CustomDialogBox.defaultProps = defaultProps;

export default injectIntl(CustomDialogBox);



// WEBPACK FOOTER //
// ./src/components/shared/dialog.component.tsx